import { Crown } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { ACCOUNT_UI as UI } from "@/data/accountI18n";
import { cn } from "@/lib/utils";

export const SupporterBadge = ({ className }) => {
  const { tc } = useLang();
  return (
    <span data-testid="supporter-badge"
      className={cn("inline-flex items-center gap-1 rounded-full bg-[hsl(var(--gold))]/20 px-2.5 py-0.5 text-xs font-semibold text-[hsl(var(--gold))] ring-1 ring-[hsl(var(--gold))]/40", className)}>
      <Crown className="h-3 w-3" />{tc(UI.supporterBadge)}
    </span>
  );
};
